import { Component, computed, signal } from '@angular/core';
import { RouterLink } from '@angular/router';

interface IndustrialSector {
  id: string;
  name: string;
  title: string;
  subtitle: string;
  description: string;
  features: readonly string[];
  image: string;
  fallbackImage: string;
  alt: string;
  iconPath: string;
  articleSlug: string;
}

@Component({
  selector: 'app-centralgas-industrial-selector',
  imports: [RouterLink],
  templateUrl: './centralgas-industrial-selector.component.html',
  styleUrl: './centralgas-industrial-selector.component.css'
})
export class CentralgasIndustrialSelectorComponent {
  readonly sectors: readonly IndustrialSector[] = [
    {
      id: '01',
      name: 'Administradores de fincas',
      title: 'Administradores de fincas',
      subtitle: 'Su aliado técnico de confianza para comunidades de propietarios.',
      description: 'Diseñamos, ejecutamos y mantenemos instalaciones individuales y comunitarias, salas térmicas, ACS y redes de gas con seguridad, eficiencia y toda la documentación en regla.',
      features: ['Instalaciones comunitarias', 'Salas térmicas y ACS', 'Mantenimiento', 'Gestión normativa'],
      image: 'assets/img/79ee46cd-bbf9-4e13-816f-086909986dfc.webp',
      fallbackImage: 'assets/img/79ee46cd-bbf9-4e13-816f-086909986dfc.jpg',
      alt: 'Edificio de uso colectivo con instalaciones gestionadas por Centralgas',
      iconPath: 'M4 21V3h16v18M8 7h2m4 0h2M8 11h2m4 0h2M9 21v-5h6v5',
      articleSlug: 'administradores-de-fincas'
    },
    {
      id: '02',
      name: 'Inmobiliarias',
      title: 'Inmobiliarias',
      subtitle: 'Instalaciones listas para vender o alquilar sin contratiempos.',
      description: 'Revisamos y adecuamos instalaciones de viviendas, locales y edificios, coordinamos las gestiones con las distribuidoras y entregamos certificados y legalizaciones.',
      features: ['Altas y puestas en servicio', 'Certificados', 'Adecuación normativa', 'Resolución de incidencias'],
      image: 'assets/img/79ee46cd-bbf9-4e13-816f-086909986dfd.webp',
      fallbackImage: 'assets/img/79ee46cd-bbf9-4e13-816f-086909986dfd.jpg',
      alt: 'Planos y herramientas para el estudio técnico de una instalación',
      iconPath: 'M15 7a5 5 0 1 0-4.6 6.96L13 16.5V19h2.5v2H18v-2.5l2-2-2.5-2.5-2 2-2.3-2.3A5 5 0 0 0 15 7ZM8 9a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z',
      articleSlug: 'inmobiliarias'
    },
    {
      id: '03',
      name: 'Talleres de chapa y pintura',
      title: 'Talleres de chapa y pintura',
      subtitle: 'Secados más rápidos, menor consumo y mayor rentabilidad.',
      description: 'Adaptamos las instalaciones de gas a cabinas de pintura y zonas de secado, ajustando la combustión y los elementos de seguridad para conseguir ciclos estables y homogéneos.',
      features: ['Cabinas de pintura', 'Ajuste de quemadores', 'Líneas de gas', 'Mantenimiento especializado'],
      image: 'assets/img/79ee46cd-bbf9-4e13-816f-086909986daf.webp',
      fallbackImage: 'assets/img/79ee46cd-bbf9-4e13-816f-086909986daf.jpg',
      alt: 'Taller de automoción con instalación de gas para cabinas de pintura',
      iconPath: 'M14.7 6.3a4 4 0 0 0-5.2 5.2l-6.1 6.1a2.1 2.1 0 0 0 3 3l6.1-6.1a4 4 0 0 0 5.2-5.2l-2.4-2.4 3.2-3.2a4 4 0 0 0-3.8 2.6Z',
      articleSlug: 'talleres-chapa-y-pintura'
    },
    {
      id: '04',
      name: 'Colegios y centros educativos',
      title: 'Colegios y centros educativos',
      subtitle: 'Confort, seguridad y eficiencia para aprender sin interrupciones.',
      description: 'Atendemos calderas centrales, ACS, piscinas, polideportivos y cocinas escolares, incluyendo la transformación completa de instalaciones de gasóleo a gas natural.',
      features: ['Calefacción central', 'Piscinas y ACS', 'Cocinas escolares', 'Conversión a gas natural'],
      image: 'assets/img/79ee46cd-bbf9-4e13-816f-086909986dfe.webp',
      fallbackImage: 'assets/img/79ee46cd-bbf9-4e13-816f-086909986dfe.jpg',
      alt: 'Fachada del colegio público Seis de Diciembre de Alcobendas',
      iconPath: 'M3 6.5 12 2l9 4.5-9 4.5-9-4.5Zm3 3.2V16c3.5 2.7 8.5 2.7 12 0V9.7M21 7v8',
      articleSlug: 'colegios-y-centros-educativos'
    },
    {
      id: '05',
      name: 'Facility management',
      title: 'Facility management',
      subtitle: 'Un único partner para instalaciones, mantenimiento y eficiencia.',
      description: 'Damos soporte técnico a contratos multiservicio en edificios e infraestructuras, con presupuestos ágiles, documentación normativa y respuesta ante incidencias.',
      features: ['Soporte multiservicio', 'Optimización térmica', 'Documentación', 'Apoyo en licitaciones'],
      image: 'assets/img/79ee46cd-bbf9-4e13-816f-086909986dff.webp',
      fallbackImage: 'assets/img/79ee46cd-bbf9-4e13-816f-086909986dff.jpg',
      alt: 'Complejo industrial atendido mediante servicios de facility management',
      iconPath: 'M3 7h18v13H3V7Zm5 0V4h8v3M3 12h18M10 10v4h4v-4',
      articleSlug: 'facility-management'
    },
    {
      id: '06',
      name: 'Lavanderías',
      title: 'Lavanderías industriales',
      subtitle: 'Energía que mueve su producción.',
      description: 'Optimizamos instalaciones y equipos de lavado, secado y planchado para mantener ciclos estables, reducir incidencias y asegurar la continuidad del servicio.',
      features: ['Calderas de vapor', 'Secadoras y calandras', 'Auditoría de consumos', 'Mantenimiento preventivo'],
      image: 'assets/img/79ee46cd-bbf9-4e13-816f-086909986daa.webp',
      fallbackImage: 'assets/img/79ee46cd-bbf9-4e13-816f-086909986daa.jpg',
      alt: 'Sala térmica industrial con calderas y equipos de combustión',
      iconPath: 'M12 2.8 6.4 8.4A7.9 7.9 0 1 0 17.6 8.4L12 2.8Zm-3 10.7a3 3 0 0 0 3 3',
      articleSlug: 'lavanderias-industriales'
    },
    {
      id: '07',
      name: 'Naves logísticas',
      title: 'Naves logísticas',
      subtitle: 'Calefacción eficiente para grandes superficies y zonas de trabajo.',
      description: 'Instalamos tubos radiantes a gas para climatizar muelles, picking y áreas críticas sin calentar todo el volumen ni depender de la potencia eléctrica disponible.',
      features: ['Tubos radiantes', 'Calefacción zonificada', 'Grandes superficies', 'Continuidad operativa'],
      image: 'assets/img/79ee46cd-bbf9-4e13-816f-086909986dab.webp',
      fallbackImage: 'assets/img/79ee46cd-bbf9-4e13-816f-086909986dab.jpg',
      alt: 'Interior de una gran nave industrial con techos altos',
      iconPath: 'M3 5h11v11H3V5Zm11 5h4l3 3v3h-7v-6ZM7 20a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm10 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z',
      articleSlug: 'naves-logisticas'
    },
    {
      id: '08',
      name: 'Panificadoras y hornos industriales',
      title: 'Panificadoras y hornos industriales',
      subtitle: 'Calor estable para una cocción uniforme y rentable.',
      description: 'Diseñamos instalaciones para hornos, cámaras de fermentación y líneas de cocción, con control de combustión, seguridad certificada y estabilidad en horas punta.',
      features: ['Hornos y quemadores', 'Cámaras de fermentación', 'Control de combustión', 'Líneas de cocción'],
      image: 'assets/img/79ee46cd-bbf9-4e13-816f-086909986dac.webp',
      fallbackImage: 'assets/img/79ee46cd-bbf9-4e13-816f-086909986dac.jpg',
      alt: 'Instalación industrial de gas con tuberías amarillas y elementos de regulación',
      iconPath: 'M8 21h8M12 17v4M9 3v8a4 4 0 1 0 6 3.5V3a3 3 0 0 0-6 0Zm3 2v9',
      articleSlug: 'panificadoras-y-hornos-industriales'
    },
    {
      id: '09',
      name: 'Polideportivos y centros deportivos',
      title: 'Polideportivos y centros deportivos',
      subtitle: 'Máximo confort para piscinas, pabellones y centros deportivos.',
      description: 'Garantizamos estabilidad térmica en piscinas, salas y pabellones mediante calderas, intercambiadores y tubos radiantes adaptados a instalaciones de alta demanda.',
      features: ['Piscinas climatizadas', 'ACS de alta demanda', 'Tubos radiantes', 'Calefacción de salas'],
      image: 'assets/img/79ee46cd-bbf9-4e13-816f-086909986dae.webp',
      fallbackImage: 'assets/img/79ee46cd-bbf9-4e13-816f-086909986dae.jpg',
      alt: 'Fachada de un polideportivo equipado con soluciones térmicas',
      iconPath: 'M8 4h8v5a4 4 0 0 1-8 0V4ZM8 6H4v2a4 4 0 0 0 4 4m8-6h4v2a4 4 0 0 1-4 4M12 13v5m-4 3h8',
      articleSlug: 'polideportivos-y-centros-deportivos'
    },
    {
      id: '10',
      name: 'Residencias de mayores',
      title: 'Residencias de mayores',
      subtitle: 'Bienestar, seguridad y confort durante las 24 horas.',
      description: 'Cuidamos calefacción, ACS, cocinas y lavanderías internas con mantenimiento preventivo, control normativo y una respuesta rápida ante cualquier incidencia.',
      features: ['Calefacción y ACS', 'Cocinas', 'Lavandería interna', 'Seguridad certificada'],
      image: 'assets/img/79ee46cd-bbf9-4e13-816f-086909986dad.webp',
      fallbackImage: 'assets/img/79ee46cd-bbf9-4e13-816f-086909986dad.jpg',
      alt: 'Edificio asistencial con instalaciones térmicas de alta demanda',
      iconPath: 'M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z',
      articleSlug: 'residencias-de-mayores'
    },
    {
      id: '11',
      name: 'Restauración y catering',
      title: 'Restauración y catering',
      subtitle: 'Cocinas que rinden, negocios que crecen.',
      description: 'Ejecutamos y mantenemos instalaciones para cocinas, obradores y líneas de catering, con combustión estable, ventilación y sistemas de corte y detección certificados.',
      features: ['Cocinas y fogones', 'Hornos industriales', 'Detección de gas', 'Líneas de calor'],
      image: 'assets/img/79ee46cd-bbf9-4e13-816f-086909986dba.webp',
      fallbackImage: 'assets/img/79ee46cd-bbf9-4e13-816f-086909986dba.jpg',
      alt: 'Hotel con instalaciones profesionales de restauración y cocina',
      iconPath: 'M4 9h16v3a8 8 0 0 1-16 0V9Zm3-6v3m5-3v3m5-3v3M3 21h18',
      articleSlug: 'restauracion-y-catering'
    }
  ];

  readonly activeIndex = signal(0);
  readonly displayedIndex = signal(0);
  readonly isTransitioning = signal(false);
  readonly displayedSector = computed(() => this.sectors[this.displayedIndex()]);

  selectSector(index: number): void {
    if (index === this.activeIndex() || this.isTransitioning()) {
      return;
    }

    this.activeIndex.set(index);
    this.isTransitioning.set(true);

    setTimeout(() => {
      this.displayedIndex.set(index);
      this.isTransitioning.set(false);
    }, 200);
  }
}
